export const SSN_INVALID_MESSAGE = 'Must contain 9 digits. Please enter a valid SSN.';
export const EIN_INVALID_MESSAGE = 'Must contain 9 digits. Please enter a valid EIN.';
export const BUSINESS_WEBSITE_INVALID_MESSAGE = 'Please enter a valid domain.';
export const ADDRESS_INVALID_MESSAGE =
  'The address could not be found on the map. Please try again.';
export const ZIP_CODE_INVALID_MESSAGE =
  'Invalid zip code, must follow the right format: 12345 or 12345-1234';
export const OPERATING_ADDRESS_INVALID_MESSAGE =
  'The operating address could not be found on the map. Please try again.';
export const OPERATING_ADDRESS_IS_RA_ADDRESS_MESSAGE =
  'The operating address cannot be the same as the registered agent address. Please enter a different address.';
export const OPERATING_ADDRESS_IS_PO_BOX_MESSAGE =
  'The operating address cannot be a P.O. Box. Please enter a different address.';
